export const enum LoginState {
  LOGGED,
  PENDING,
  NOT_LOGGED,
  LOGIN_REJECTED,
  LOGGING_OUT
}

export interface AuthState {
  loginState: LoginState;
  loginError?: string | null | undefined;
  registrationError?: string | null | undefined;
  resetPasswordError?: string | null | undefined;
  changePasswordError?: string | null | undefined;
  forgotPasswordError?: string | null | undefined;
  isChangePasswordSuccess?: boolean;
  isRegistrationSuccess?: boolean;
  isForgotPasswordSuccess?: boolean;
}
